import { useCalculatorContext } from '../../contexts';
import { Disclaimer } from '../Disclaimer';
import { PriceSummary } from '../PriceSummary';
import { ProductPage } from '../ProductPage/ProductPage';
import { Welcome } from '../Welcome';
import styles from "./styles.module.css";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function CalculatorContent(_ref) {
  var bgImage = _ref.bgImage;
  var _useCalculatorContext = useCalculatorContext(),
    selectedProduct = _useCalculatorContext.selectedProduct,
    layoutType = _useCalculatorContext.layoutType;
  var isDesktop = layoutType === 'desktop';
  if (!selectedProduct) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Welcome, {
        image: bgImage
      }), /*#__PURE__*/_jsx(Disclaimer, {
        className: styles.disclaimer
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles.calculator,
    "data-layout-type": layoutType,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.pageWrapper,
      children: [/*#__PURE__*/_jsx(ProductPage, {
        selectedProduct: selectedProduct,
        className: styles.page
      }), isDesktop && /*#__PURE__*/_jsx(Disclaimer, {
        className: styles.disclaimer
      })]
    }), /*#__PURE__*/_jsx(PriceSummary, {
      className: styles.priceSummary
    }), !isDesktop && /*#__PURE__*/_jsx(Disclaimer, {})]
  });
}